<div class="tile__status" data-testid="tile"
    [ngClass]="{ 'tile__status--active': tile.params.percentage > 0,
        'tile__status--default': !(tile.params.percentage>0) }">
    <div class="tile__svg--other-wrapper bg-img">
        <img class="tile__svg--other" ngSrc="/assets/img/id_icons/15.svg"
             width="50" height="50" alt="" />
    </div>
    <div class="tile__subtitle">
        <floating-subtitle class="tile__subtitle-row"
                           [text]="subtitle(246)">
        </floating-subtitle>
        <floating-subtitle [position]="'right'"
                           class="tile__subtitle-row font-bold font-15 tile__subtitle-row--right"
                           *ngIf="tile.params.txtId !== 0"
                           [text]="subtitle(tile.params.txtId)">
        </floating-subtitle>
    </div>
    <div class="tile__value tile__indicator" data-testid="tile-value"
        *ngIf="tile.params.percentage > 0">
        <circle-progress [value]="tile.params.percentage"
                         [showPath]="true"
                         [angleEnd]="tile.params.percentage * 3.6">
        </circle-progress>
    </div>
    <div class="tile__setting cursor-pointer"
         [ngClass]="{ 'bg-light-shadow': tile.elementMenu.duringChange === 't' }"
         *ngIf="tile.elementMenu && tile.menuId !== 0"
         (click)="goControl()">
        <img ngSrc="/assets/img/icons/{{ getIconName() }}.svg"
             width="30" height="30" alt="" />
        <p class="tile__setting-alert font-12 color-light"
           *ngIf="tile.elementMenu.duringChange === 't'">
           {{ subtitle(3162) }}
        </p>
    </div>
</div>
